<template>
  <div>
    <p class="label">{{ name }} *</p>
    <input
      type="file"
      name="file-7[]"
      id="file-7"
      ref="file"
      class="inputfile inputfile-6"
      data-multiple-caption="{count} files selected"
      multiple
      @change="$emit('file-uploaded', $refs.file.files)"
    />
    <label for="file-7" class="md-layout md-alignment-center-space-between"
      ><span class="md-layout-item">
        {{ filename }}
      </span>
      <strong
        class="md-layout-item md-size-33 md-xsmall-size-60 md-small-size-60"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="17"
          viewBox="0 0 20 17"
        >
          <path
            d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
          />
        </svg>
        Choose a file&hellip;</strong
      ></label
    >
  </div>
</template>

<script>
export default {
  name: "fileInput",
  props: {
    name: {
      type: String,
      required: true,
      default: "Upload File"
    },
    filename: {
      type: String,
      required: true,
      default: "Select File"
    },
  },



}
</script>

<style  scoped>
.label {
  padding-bottom: 5px;
}
.inputfile + label {
  font-size: 1.25rem;
  /* 20px */
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  /* display: inline-block; */
  overflow: hidden;
  padding: 0.625rem 1.25rem;
  /* 10px 20px */
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.inputfile:focus + label,
.inputfile.has-focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

.inputfile + label svg {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;
  margin-top: -0.25em;
  /* 4px */
  margin-right: 0.25em;
  /* 4px */
}

/* style 6 */

.inputfile-6 + label {
  border: 1px solid #d3394c;
  border-radius: 3px;
  background-color: #efefef;
  padding: 0;
  color: #213a63;
}

.inputfile-6:focus + label,
.inputfile-6.has-focus + label,
.inputfile-6 + label:hover {
  border-color: #ff7d53;
}

.inputfile-6 + label span,
.inputfile-6 + label strong {
  /* padding: 0.625rem 1.25rem; */
  padding: 0.7em;
  /* 10px 20px */
}

.inputfile-6 + label span {
  /* width: 200px; */
  font-weight: 100;
  min-height: 2em;
  /* display: inline-block; */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: top;
}

.inputfile-6 + label strong {
  height: 100%;
  color: #fff;
  background-color: #ff5722;
  font-size: 1.2em;
  font-weight: 100;
  /* display: inline-block; */
}

.inputfile-6:focus + label strong,
.inputfile-6.has-focus + label strong,
.inputfile-6 + label:hover strong {
  background-color: #ff7d53;
}
</style>


// WEBPACK FOOTER //
// src/components/ui-components/file-input.vue